import React from 'react'
import AcceptModal from '@/components/AcceptModal'
import ClassicAcceptModal from '@/components/AcceptModal/Classic'

interface ErrorMessage {
  message: string;
  description?: string;
}

type SetAcceptModalFunction = (modal: React.ReactNode) => void;

export const showErrorModal = (
  message: ErrorMessage,
  setAcceptModal: SetAcceptModalFunction
): void => {
  setAcceptModal(
    <AcceptModal handleAgree={() => { }} withoutCancel={true}>
      <ClassicAcceptModal
        name={message.message}
        description={message.description || ''}
      />
    </AcceptModal>
  )
}